var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container-outer",attrs:{"data-aos":"zoom-out","data-aos-offset":"400","data-aos-id":_vm.aosId}},[_c('div',{staticClass:"chart-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }